import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the division state domain
 */

const selectDivisionDomain = (state) => state.get("division", initialState)

/**
 * Other specific selectors
 */

export const makeSelectHasDivisions = () =>
  createSelector(selectDivisionDomain, (state) => state.get("hasDivisions"))

export const makeSelectOrgFirst = () =>
  createSelector(selectDivisionDomain, (state) => state.get("orgFirst"))

export const makeSelectGetDivisions = () =>
  createSelector(selectDivisionDomain, (state) => state.get("getDivisions"))
export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectImportedSummary = () =>
  createSelector(selectDivisionDomain, (state) => state.get("importedSummary"))

export const makeSelectSubdivisionsTable = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("subdivisionsTable")
  )

export const makeSelectIsLoadingSubdivisionsTable = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("isLoadingSubdivionsTable")
  )

export const makeSelectDivisionsUnassigned = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("divisionsUnassigned")
  )

export const makeSelectIsLoadingDivisionsUnassigned = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("isLoadingDivisionsUnassigned")
  )

export const makeSelectMessageDeleteSubdivision = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("messageDeleteSubdivision")
  )

export const makeSelecDivisionParentsTable = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("divisionParentsTable")
  )

export const makeSelectIsLoadingDivisionParentsTable = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("isLoadingDivisionParentsTable")
  )

export const makeSelectCollaboratorsTable = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("collaboratorsTable")
  )

export const makeSelectIsLoadingCollaboratorsTable = () =>
  createSelector(selectDivisionDomain, (state) =>
    state.get("isLoadingCollaboratorsTable")
  )

export const makeSelectIsDownloading = () =>
  createSelector(selectDivisionDomain, (state) => state.get("isDownloading"))

export const makeSelectIsUploading = () =>
  createSelector(selectDivisionDomain, (state) => state.get("isUploading"))

export const makeSelectTableView = () =>
  createSelector(selectDivisionDomain, (state) => state.get("tableView"))

export const makeSelectTreeData = () =>
  createSelector(selectDivisionDomain, (state) => state.get("treeData"))

export const makeSelectExpandedRows = () =>
  createSelector(selectDivisionDomain, (state) => state.get("expandedRows"))

export const makeSelectLastOfTree = () =>
  createSelector(selectDivisionDomain, (state) => state.get("lastOfTree"))

export const makeSelectIsLoadingCreate = () =>
  createSelector(selectDivisionDomain, (state) => state.get("isLoadingCreate"))

export const makeSelectResetDivisionForm = () =>
  createSelector(selectDivisionDomain, (state) => state.get("reset"))

/**
 * Default selector used by Division
 */

const makeSelectDivision = () =>
  createSelector(selectDivisionDomain, (substate) => substate.toJS())

export default makeSelectDivision
export { selectDivisionDomain }
